import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../../interfaces/commonProps';
import { spacingPropTypes } from '../../../interfaces/layoutProps';
export const commonOptionPropTypes = {
    autoComplete: PropTypes.string,
    checked: PropTypes.bool,
    children: PropTypes.node.isRequired,
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    hint: PropTypes.string,
    inputId: PropTypes.string.isRequired,
    inputRef: PropTypes.func,
    invalid: PropTypes.bool,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    validationMessage: PropTypes.string,
    value: PropTypes.string,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=GenericOption.types.js.map